<template>
    <UBadge :label="label" :color="color" variant="subtle" size="xs" />
</template>

<script setup lang="ts">
const props = defineProps<{
    status: string
}>()

const labels: Record<string, string> = {
    success: 'Activated',
    duplicate: 'Duplicate',
    invalid_data: 'Invalid Data',
    no_credential_match: 'No Record',
    active_subscription_exists: 'Already Active',
    auth_creation_failed: 'Phone Number Taken',
    customer_creation_failed: 'Customer Failed',
    subscription_creation_failed: 'Membership Failed',
    whatsapp_failed: 'WhatsApp Failed',
    no_family_head: 'No Family Head',
    family_link_failed: 'Family Not Linked',
}

const colors: Record<string, string> = {
    success: 'green',
    duplicate: 'amber',
    active_subscription_exists: 'amber',
    whatsapp_failed: 'orange',
    family_link_failed: 'amber',
}

const label = computed(() => labels[props.status] || props.status)
const color = computed(() => colors[props.status] || 'red')
</script>
